import { render } from "./DefaultWell.vue?vue&type=template&id=cfb45400"
import script from "./DefaultWell.vue?vue&type=script&lang=js"
export * from "./DefaultWell.vue?vue&type=script&lang=js"
script.render = render

export default script